"use client"

import type { CompanyListProps } from "@/types/types"
import { ComponentConfig } from "@measured/puck"
import { twMerge } from "tailwind-merge"
import { useCompanyList } from "../../../../../../../hook/useCompanyList"
import { generateResponsiveCSS } from "../../../lib/helper"
import { CompanyListContent } from "./components/CompanyListContent"

export const RenderConfig: ComponentConfig<CompanyListProps> = {
  render: ({
    title,
    companies,
    gap,
    maxWidth,
    titleFontSize,
    titleFontWeight,
    titleLineHeight,
    className,
    styles,
    responsiveType,
    id: componentId,
  }: CompanyListProps & { id?: string }) => {
    const { id } = useCompanyList({
      companies,
      componentId,
    })

    const mergedStyles = styles || {}
    const responsiveCSS = generateResponsiveCSS(id, mergedStyles, responsiveType || "mobileFirst")

    return (
      <>
        {responsiveCSS}
        <CompanyListContent
          id={id}
          title={title}
          companies={companies}
          gap={gap}
          maxWidth={maxWidth}
          titleFontSize={titleFontSize}
          titleFontWeight={titleFontWeight}
          titleLineHeight={titleLineHeight}
          className={twMerge(className)}
        />
      </>
    )
  },
}
